"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const broswer_storage_1 = __importDefault(require("@makeblock/broswer-storage"));
const request_1 = __importDefault(require("./request"));
const domains_1 = __importDefault(require("./config/domains"));
const mr = new request_1.default();
// 设置使用缓存策略为 cookie
broswer_storage_1.default.strategy = 'cookie';
// 设置 cookie 域名
broswer_storage_1.default.config({
    // 域
    domain: '.makeblock.com',
    // 过期时间： 一年
    expires: 60 * 24 * 365
});
var PAGE_MODE;
(function (PAGE_MODE) {
    PAGE_MODE["PAGE"] = "page";
    PAGE_MODE["WIN"] = "win";
})(PAGE_MODE = exports.PAGE_MODE || (exports.PAGE_MODE = {}));
var CLIENT_ENV;
(function (CLIENT_ENV) {
    CLIENT_ENV["DEV"] = "dev";
    CLIENT_ENV["TEST"] = "test";
    CLIENT_ENV["PROD"] = "prod";
    CLIENT_ENV["LOCAL"] = "local";
})(CLIENT_ENV = exports.CLIENT_ENV || (exports.CLIENT_ENV = {}));
var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["LOGIN"] = "login";
    MESSAGE_TYPE["REGISTER"] = "register";
    MESSAGE_TYPE["FINDPWD"] = "findpwd";
    MESSAGE_TYPE["SWITCH_HSOT"] = "switchHost";
})(MESSAGE_TYPE = exports.MESSAGE_TYPE || (exports.MESSAGE_TYPE = {}));
var MAKEBLOCK_PLATFORM;
(function (MAKEBLOCK_PLATFORM) {
    // 网页端慧编程IDE
    MAKEBLOCK_PLATFORM["MBLOCK_WEB"] = "mblock_web";
    // PC端慧编程IDE
    MAKEBLOCK_PLATFORM["MBLOCK_PC"] = "mblock_pc";
    // 移动端慧编程IDE
    MAKEBLOCK_PLATFORM["MBLOCK_MOBILE"] = "mblock_mobile";
    // 壹盒
    MAKEBLOCK_PLATFORM["ONE_BOX"] = "one_box";
    // STEAM教育服务平台学生
    MAKEBLOCK_PLATFORM["STEAM_PLATFORM_STU"] = "steam_platform_stu";
    // STEAM教育服务平台老师
    MAKEBLOCK_PLATFORM["STEAM_PLATFORM_TEACHER"] = "steam_platform_teacher";
    // 作品社区
    MAKEBLOCK_PLATFORM["COMMUNITY"] = "community";
    // 扩展设计器
    MAKEBLOCK_PLATFORM["EXT_BUILDER"] = "ext_builder";
    // MakeX赛事
    MAKEBLOCK_PLATFORM["MAKEX"] = "makex";
})(MAKEBLOCK_PLATFORM = exports.MAKEBLOCK_PLATFORM || (exports.MAKEBLOCK_PLATFORM = {}));
/**
 * 用户 Token 缓存 key
 */
const TOKEN_KEY = 'utoken';
/**
 * 语言缓存 KEY
 */
const LANG_KEY = 'IntlLang';
/**
 * 获取系统语言，没有则返回 null
 *
 * @author HUANGE
 * @date 2020-03-10
 * @returns
 */
const systemLang = () => {
    const { language, languages } = navigator;
    if (language) {
        return language;
    }
    if (Array.isArray(languages) && languages.length > 0) {
        return languages[0];
    }
    return null;
};
exports.POST_MESSAGE_SOURCE = 'makeblock-passport';
/**
 * Passport 接入端服务
 *
 * @author HUANGE
 * @date 2020-03-03
 * @export
 * @class PassportClient
 */
class PassportClient {
    constructor() {
        /**
         * 国际版
         *  默认不是国际版
         *
         * @private
         * @type {boolean}
         */
        this._intl = false;
        this._env = CLIENT_ENV.PROD;
        /**
         * 接入的平台标识
         *
         * @private
         * @type {string}
         */
        this._platform = '';
        /**
         * 登录完成跳转回去的链接地址，默认当前页面
         *
         * @private
         * @type {string}
         */
        this._redirect = encodeURIComponent(location.href);
        /**
         * 加载模式
         *  页面或者窗口模式
         * @private
         * @type {('page' | 'win')}
         */
        this._mode = PAGE_MODE.PAGE;
        /**
         * 是否显示切换服务的操作
         *
         * @private
         * @type {boolean}
         */
        this._showSwitchHost = true;
        this._token = broswer_storage_1.default.get(TOKEN_KEY);
    }
    /**
     * 获取 Passport 域名
     *
     * @readonly
     */
    get domain() {
        const domains = domains_1.default[this._env];
        if (this._intl) {
            return domains.intl;
        }
        else {
            return domains.cn;
        }
    }
    /**
     * 设置 cookie domain
     *
     */
    set cookieConfig(attrs) {
        // 设置 cookie 域名
        broswer_storage_1.default.config(attrs);
    }
    /**
     * 设置是否国际版
     *
     */
    set intl(value) {
        this._intl = value;
        if (value === true) {
            broswer_storage_1.default.config({
                domain: '.mblock.cc'
            });
        }
    }
    /**
     * 设置是否国际版
     *
     */
    set env(value) {
        this._env = value;
    }
    /**
     * 设置 接入的平台标识
     */
    set platform(value) {
        this._platform = value;
    }
    /**
     * 设置语言
     *
     */
    get lang() {
        return broswer_storage_1.default.get(LANG_KEY) || systemLang() || 'en';
    }
    /**
     * 设置语言
     *
     */
    set lang(value) {
        broswer_storage_1.default.set(LANG_KEY, value);
    }
    /**
     * 设置 登录完成跳转回去的链接地址
     *
     */
    set redirect(value) {
        this._redirect = encodeURIComponent(value);
    }
    set mode(value) {
        this._mode = value;
    }
    set showSwitchHost(value) {
        this._showSwitchHost = value;
    }
    /**
     * 获取 passport url
     *
     * @readonly
     * @private
     */
    get baseUrl() {
        return `${this.domain.page}${this.lang}`;
    }
    loginQuery() {
        const querys = [];
        if (this._platform) {
            querys.push(`p=${this._platform}`);
        }
        if (this._redirect) {
            querys.push(`r=${this._redirect}`);
        }
        if (this._mode === 'win') {
            querys.push(`md=${this._mode}`);
        }
        if (this._showSwitchHost === false) {
            querys.push('sh=false');
        }
        return querys.join('&');
    }
    /**
     * 获取 登录页面 URL
     *
     * @readonly
     * @type {string}
     */
    get url() {
        return `${this.baseUrl}/login?${this.loginQuery()}`;
    }
    /**
     * 获取学生账号登录 URL
     *
     * @readonly
     */
    get stuLoginUrl() {
        return `${this.baseUrl}/login/stu?${this.loginQuery()}`;
    }
    /**
     * 获取用户主页链接
     *
     * @readonly
     */
    get profile() {
        return `${this.baseUrl}/profile?ut=${this._token}`;
    }
    /**
     * 获取链接
     *
     * @author HUANGE
     * @date 2020-05-27
     * @param {string} pathname
     * @returns
     */
    getUrl(pathname) {
        return `${this.baseUrl}/${pathname}?${this.loginQuery()}`;
    }
    /**
     * 获取 token
     *
     * @readonly
     */
    get token() {
        return this._token; // bStorage.get(TOKEN_KEY);
    }
    /**
     * 设置 token
     * 如果 value 为空，则删除 token 缓存
     */
    set token(value) {
        this._token = value;
        if (value) {
            broswer_storage_1.default.set(TOKEN_KEY, value);
        }
        else {
            broswer_storage_1.default.remove(TOKEN_KEY);
        }
    }
    set close(value) {
        this._close = value;
    }
    set switchHost(value) {
        this._switchHost = value;
    }
    /**
     * 注册消息接收
     *
     * @author HUANGE
     * @date 2020-03-11
     * @returns
     */
    listenMessage() {
        /**
         * 收到 Passport web 的消息
         *
         * @author HUANGE
         * @date 2020-03-10
         * @private
         * @param {MessageEvent} ev
         */
        const _receiveMessage = (ev) => {
            const { source, payload } = ev.data;
            if (source === exports.POST_MESSAGE_SOURCE) {
                const { type } = payload;
                if (type === MESSAGE_TYPE.LOGIN || type === MESSAGE_TYPE.REGISTER || type === MESSAGE_TYPE.FINDPWD) {
                    const { token } = payload;
                    if (token) {
                        this._token = token;
                    }
                    if (typeof this._close === 'function') {
                        this._close(payload);
                        remove();
                    }
                }
                if (type === MESSAGE_TYPE.SWITCH_HSOT) {
                    if (typeof this._switchHost === 'function') {
                        this._switchHost(payload.data);
                    }
                }
            }
        };
        /**
         * 移除事件监听
         */
        const remove = () => {
            window.removeEventListener('message', _receiveMessage);
        };
        window.addEventListener('message', _receiveMessage);
        return remove;
    }
    /**
     * 退出登录 -> 删除缓存 token
     *
     * @author HUANGE
     * @date 2020-03-06
     */
    logout() {
        const ut = this.token;
        if (!ut) {
            return Promise.reject(new Error('utoken is empty.'));
        }
        const url = `${this.domain.api}/user/logout`;
        // mr.token = ut;
        return new Promise((resolve, reject) => {
            mr.axios
                .post(url)
                .then((data) => {
                this.token = null;
                resolve(data);
            })
                .catch(reject);
        });
    }
    /**
     * 获取用户信息
     *
     * @author HUANGE
     * @date 2020-03-06
     * @returns
     */
    userInfo() {
        const ut = this.token;
        if (!ut) {
            return Promise.reject(new Error('utoken is empty.'));
        }
        const url = `${this.domain.api}/user/basic`;
        // mr.token = ut;
        return mr.axios.get(url);
    }
}
const userClient = new PassportClient();
mr.axios.interceptors.request.use((config) => {
    if (userClient.token) {
        config.headers.common['utoken'] = userClient.token;
    }
    const { url, params = {} } = config;
    if (url) {
        let matchArrs = url.match(/(:[^{:&/|_}]*)/g);
        if (Array.isArray(matchArrs) && matchArrs.length > 0) {
            matchArrs.forEach((matchKey) => {
                const key = matchKey.replace(':', '');
                if (key.length >= 1) {
                    if (key in params) {
                        config.url = url.replace(matchKey, params[key]);
                        delete config.params[key];
                    }
                }
            });
        }
    }
    return Promise.resolve(config);
}, (error) => {
    return Promise.reject(error);
});
exports.MRequest = request_1.default;
exports.default = userClient;
